import { render } from "./ResetLicensingButton.vue?vue&type=template&id=47bcb434"
import script from "./ResetLicensingButton.vue?vue&type=script&lang=js"
export * from "./ResetLicensingButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__